import { fetchAppsAction, fetchAppInfoAction } from "./actions"
import { QueryParams } from "../../../types"

export const fetchAppsOps = (params: QueryParams) => fetchAppsAction.started(params)

export const fetchAppInfoOps = (appCode: string) =>
  fetchAppInfoAction.started({ appCode })
